import { useAppContext } from "../../../../_context";
import DayRow from "./DayRow";
import Col from "react-bootstrap/Col";

const DayRows = ({ allErrors }) => {
  const [{ tx }] = useAppContext();

  return (
    <>
      <div className="row mb-2 text-grey-1">
        <Col md={4} className="d-none d-md-block">
          <span className="small">{tx["Days"]}</span>
        </Col>
        <Col md={8}>
          <div className="row">
            <Col xs={6}>
              <span className="small">{tx["Open"]}</span>
            </Col>
            <Col xs={6}>
              <span className="small">{tx["Close"]}</span>
            </Col>
          </div>
        </Col>
      </div>

      {[
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ].map((day, index) => {
        return (
          <DayRow key={index} index={index} day={day} allErrors={allErrors} />
        );
      })}
    </>
  );
};

export default DayRows;
